import { mapActions, mapGetters } from 'vuex'
import { debounce, snakeCase } from 'lodash'

import mixins from '@/mixins'
import course from '@/mixins/course'
import validation from '@/mixins/validation'

import Draggable from 'vuedraggable'

import { courseContentSocialsTableHead } from '@/modules/courses/helpers/content-socials'

export default {
  name: 'setting-countries-socials',
  mixin: [course, mixins, validation],
  data () {
    return {
      showRemoveDialog: false,
      showActionsDialog: false,
      valid: false,
      removingItem: null,
      editItem: null,
      socials: [],
      payload: {
        name: '',
        link: '',
        statusId: '',
        typeId: '',
        sort: ''
      }
    }
  },
  components: {
    Draggable
  },
  watch: {
    'list' () {
      this.socials = this.list
    }
  },
  computed: {
    ...mapGetters({
      setting: 'courses/setting',
      list: 'settingCountriesSocials/list',
      isListLoading: 'settingCountriesSocials/isListLoading',
      isLoading: 'settingCountriesSocials/isLoading',
      listLength: 'settingCountriesSocials/listLength',
      limit: 'settingCountriesSocials/limit',
      skip: 'settingCountriesSocials/skip',
      profile: 'profile/profile',
      currentCountry: 'settingCountries/currentItem'
    }),
    courseContentSocialsTableHead
  },
  created () {
    if (!this.list.length) {
      this.fetchList({ countryId: this.currentCountry.id }).then(() => {
        this.socials = this.list
      })
    } else {
      this.socials = this.list
    }
  },
  methods: {
    ...mapActions({
      fetchList: 'settingCountriesSocials/GET_LIST',
      remove: 'settingCountriesSocials/DELETE',
      update: 'settingCountriesSocials/UPDATE',
      create: 'settingCountriesSocials/CREATE',
      updateSort: 'settingCountriesSocials/UPDATE_SORT'
    }),

    resetValidation () {
      Object.keys(this.payload).forEach(e => {
        this.payload[e] = ''
      })
      this.showActionsDialog = false
      this.editItem = null
    },
    changeDialogActions (item = null, status) {
      this.editItem = item
      if (item) {
        Object.assign(this.payload, item)
      } else {
        this.resetValidation()
      }
      this.showActionsDialog = status
    },
    openDialogDelete (item) {
      this.showRemoveDialog = true
      this.removingItem = item
    },
    removeListItem () {
      this.remove({
        countryId: this.currentCountry.id,
        id: this.removingItem.id
      }).then(() => {
        this.showRemoveDialog = false
        this.$toasted.success(this.$t('success_deleted'))
      })
    },
    createRequestPayload () {
      const data = Object.assign(this.payload)
      const formData = {}
      Object.keys(data).forEach(e => {
        formData[snakeCase(e)] = data[e]
      })
      formData.countryId = this.currentCountry.id
      return formData
    },
    submit () {
      this.$refs.form.validate()
      this.$refs.observer.validate()
      if (this.valid) {
        if (!this.editItem) {
          this.create(this.createRequestPayload()).then(response => {
            this.$toasted.success(this.$t('success_created'))
            this.resetValidation()
          })
        } else {
          this.update(this.createRequestPayload()).then(() => {
            this.$toasted.success(this.$t('success_updated'))
            this.resetValidation()
          })
        }
      }
    },
    sendRequest: debounce(function () {
      this.fetchList({ countryId: this.currentCountry.id })
    }, 1000),
    changeSort: debounce(function (e) {
      if (e.hasOwnProperty('moved')) {
        const formData = {
          countryId: this.currentCountry.id,
          socials: this.socials.map(e => e.id)
        }
        this.updateSort(formData).then(() => {
          this.$toasted.success(this.$t('success_change_position'))
        })
      }
    }, 2000)
  }
}
